import { render, staticRenderFns } from "./TcmBrainSetting.vue?vue&type=template&id=639e24c2&scoped=true"
import script from "./TcmBrainSetting.vue?vue&type=script&lang=ts"
export * from "./TcmBrainSetting.vue?vue&type=script&lang=ts"
import style0 from "./TcmBrainSetting.vue?vue&type=style&index=0&id=639e24c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e24c2",
  null
  
)

export default component.exports